module.exports = __webpack_public_path__ + "0fbe3d7562607e878c97733b99ffb3c7.MP3";